<template>
  <div data-testid="workflows-status">
    <!-- Legend chips -->
    <v-chip 
      data-testid="workflows-status__legend-enabled"
      :class="`font-weight-bold mr-1 mb-1 mt-2 border-left-success`" 
      small
    >
      Enabled
    </v-chip>
    <v-chip 
      data-testid="workflows-status__legend-disabled"
      :class="`font-weight-bold mr-1 mb-1 mt-2 border-left-error error--text`" 
      small
    >
      Disabled
    </v-chip>
    
    <lb-divider class='mt-2 mb-2' />
    
    <!-- Workflow status chips -->
    <div class="chip-container" data-testid="workflows-status__chips-container">
      <div v-for="(item, index) in allworkflowstext" :key='item'>
        <v-chip
          data-testid="workflows-status__chip"
          :class="`font-weight-bold mr-1 mt-2 ${isWorkflowDisabled(index) ? 'border-left-error error--text' : 'border-left-success'}`"
          small
        >
          {{ item }}
        </v-chip>
      </div>
    </div>

    <!-- Divider before SOD -->
    <lb-divider class='mt-4 mb-2' />
    <v-chip
      data-testid="workflows-status__sod-chip"
      :class="`font-weight-bold mr-1 mb-1 mt-2 ${sodEnabled ? 'border-left-success' : 'border-left-error error--text'}`"
      small
    >
      SOD 
    </v-chip>
  </div>
</template>

<script>
export default {
  name: 'WorkflowsStatus',
  props: {
    allworkflowstext: {
      type: Array,
      required: true,
      default: () => []
    },
    workflowtext: {
      type: Array,
      required: true,
      default: () => []
    },
    allworkflowskeys: {
      type: Array,
      required: true,
      default: () => []
    },
    sodEnabled: {
      type: Boolean,
      required: true,
      default: true
    }
  },
  methods: {
    isWorkflowDisabled(index) {
      const workflowKey = this.allworkflowskeys[index];
      return this.workflowtext
        .map(workflow => workflow && workflow.toLowerCase())
        .includes(workflowKey.toLowerCase());
    }
  }
}
</script>

<style scoped>
.chip-container {
  display: flex;
  flex-wrap: wrap;
}

.border-left-success {
  border-left: 4px solid #4caf50 !important;
}

.border-left-error {
  border-left: 4px solid #f44336 !important;
}
</style>